// @flow
const EVENT_TYPE_KEY = '$e';
const EVENT_TYPES = {
  connect: 'C',
  define: 'D',
  inside: 'I',
  enter: 'E',
  exit: 'X',
};

export class Geofence {
  handlers = Object.keys(EVENT_TYPES).reduce(
    (agg, key) => ({
      ...agg,
      [EVENT_TYPES[key]]: () => {},
    }),
    {}
  );

  constructor(endpoint, handlers) {
    this.endpoint = endpoint;

    Object.keys(EVENT_TYPES).forEach(t => {
      const handlerName = `on${t[0].toUpperCase()}${t.slice(1)}`;
      if (Object.keys(handlers).includes(handlerName)) {
        this.handlers[EVENT_TYPES[t]] = handlers[handlerName];
      }
    });

    this.connect();
  }

  constructWebSocketUri = () => {
    const { protocol: proto, host, hostname } = window.location;

    const dev =
      process.env.FE_NODE_ENV === 'development' && hostname === 'localhost';
    const wsHost = dev ? `${hostname}:${process.env.API_PORT}` : host;
    const wsProto = proto.endsWith('s:') ? 'wss' : 'ws';

    return `${wsProto}://${wsHost}${this.endpoint}`;
  };

  connect = () => {
    this.ws = new WebSocket(this.constructWebSocketUri());
    this.ws.onmessage = this.handleMessage;
    this.ws.onclose = this.handleClose;
    this.handlers[EVENT_TYPES.connect]();
  };

  close = () => {
    // Do not try to reconnect when being closed on purpose
    this.ws.onclose = null;
    this.ws.close();
  };

  send = message => {
    this.ws.send(
      typeof message === 'string' ? message : JSON.stringify(message)
    );
  };

  handleMessage = ({ data }) => {
    try {
      const { [EVENT_TYPE_KEY]: eventType, ...feature } = JSON.parse(data);
      this.handlers[eventType](feature);
    } catch (e) {
      if (process.env.FE_NODE_ENV === 'development') {
        throw e;
      }
    }
  };

  handleClose = () => {
    setTimeout(() => this.connect(), 1000);
  };
}



// WEBPACK FOOTER //
// ./utils/rt.js